import React from "react";
import { isDarkTheme } from "app/utils/utils";

interface InsuredIconProps {
  fill?: string;
  width?: string;
  height?: string;
}

const InsuredIcon: React.FC<InsuredIconProps> = ({ fill, width = "100%", height = "100%" }) => {
  const defaultFill = fill || (isDarkTheme() ? "#fff" : "#004781");

  return (
    <svg
      id="uuid-3922af4a-51bd-4ff4-85af-22bddd18bc2e"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 420.95 326.35"
    >
      <g id="uuid-eb641e30-a1d6-408d-8f56-fd89577a1cdb" data-name="Layer 1">
        <g id="uuid-18359bde-0087-4a15-9054-a954822dac66" data-name="30-Insured-Details">
          <path
            fill={defaultFill}
            d="M414.77,175.45l-83.51-48.22c-3.81-2.19-8.53-2.19-12.33,0l-83.51,48.22c-4.07,2.35-6.43,6.73-6.14,11.42v.19c.27,4.15.61,8.24,1.03,12.16.86,8.02,2.08,15.79,3.62,23.08,9.17,43.48,28.98,68.07,43.98,81.04.83.71,1.65,1.4,2.48,2.08,17.38,14.17,34.03,18.86,40.39,20.23,1.37.29,2.23.42,2.59.47.57.08,1.15.12,1.73.12s1.14-.04,1.71-.12c.92-.12,22.97-3.31,45.48-22.78,20-17.29,44.67-51.5,48.62-116.28v-.18c.29-4.7-2.06-9.08-6.14-11.43ZM325.09,154.13c1.44,0,2.88.37,4.17,1.11l61.16,35.31c2.89,1.66,4.51,4.86,4.12,8.14-2.18,18.64-6.54,35.29-12.9,49.54-6.37,14.25-14.73,26.11-24.93,35.19-6.19,5.51-12.99,9.98-20.2,13.27-3.1,1.42-6.18,2.58-9.16,3.45-1.51.44-3.12.44-4.65,0-1.72-.5-3.53-1.12-5.37-1.84-14.49-5.71-40.85-21.77-54.55-65.21-2.53-8.04-4.54-16.73-5.96-25.83-.44-2.77-.83-5.62-1.16-8.47-.39-3.33,1.22-6.56,4.1-8.23l61.17-35.31c1.28-.74,2.72-1.11,4.16-1.11Z"
          />
          <path
            fill={defaultFill}
            d="M253.4,318.73c-1.88,4.7-6.19,7.62-11.24,7.62H24.42c-7.85,0-15.02-3.39-19.67-9.31-4.21-5.35-5.72-12.16-4.14-18.67,15.57-64.11,86.8-110.64,169.38-110.64,12.41,0,24.78,1.04,36.76,3.11,5.31.91,9.43,5.3,10.02,10.66l.03.23c.42,3.83-.94,7.54-3.74,10.18-2.79,2.62-6.56,3.74-10.34,3.09-10.73-1.86-21.74-2.8-32.73-2.8-35.53,0-69.93,9.78-96.86,27.53-24.62,16.25-41.65,38.25-48.15,62.14h216.91c3.13,0,6.1,1.2,8.38,3.37h.01s.2.2.2.2c3.68,3.5,4.79,8.59,2.92,13.29Z"
          />
          <path
            fill={defaultFill}
            d="M251.26,60.84l-26.34-44.72c-5.86-9.94-16.66-16.12-28.2-16.12h-53.79c-11.54,0-22.35,6.18-28.2,16.12l-26.35,44.72c-6.04,10.25-6.04,22.98,0,33.22l26.35,44.72c5.85,9.94,16.66,16.12,28.2,16.12h53.79c11.54,0,22.34-6.18,28.2-16.12l26.34-44.72c6.04-10.24,6.04-22.97,0-33.22ZM196.72,130.75h-53.79c-3.03,0-5.86-1.62-7.39-4.23l-26.35-44.72c-1.58-2.68-1.58-6.02,0-8.7l26.35-44.72c1.53-2.61,4.36-4.22,7.39-4.22h53.79c3.02,0,5.85,1.61,7.39,4.22l26.34,44.72c1.58,2.68,1.58,6.02,0,8.7l-26.34,44.72c-1.54,2.61-4.37,4.23-7.39,4.23Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default InsuredIcon;
